import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeHandicapModalAjoutComponent } from '../modal/typeHandicap-modal-ajout/typeHandicap-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TypeHandicapModalDetailComponent } from '../modal/typeHandicap-modal-detail/typeHandicap-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-typeHandicap',
	templateUrl: './list-typeHandicap.component.html',
	styleUrls: ['./list-typeHandicap.component.scss']
})
export class ListTypeHandicapComponent implements OnInit {
	typeHandicap: TypeHandicap[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	typeHandicapCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editTypeHandicapModalRef: BsModalRef;
	addTypeHandicapModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getTypeHandicap();
		this.isAddable = true;
	}

	getTypeHandicap(): void {
		this.isListingLoading = true;
		this.facade.typeHandicapService.getAllTypeHandicaps().subscribe({
			next: (val) => {
				this.typeHandicap = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.typeHandicap.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.typeHandicap = [];
			}
		});
	}

	selectTypeHandicap(typeHandicap: TypeHandicap): void {
		const link = ['/typeHandicap', typeHandicap.id];
		this.router.navigate(link);
	}

	importTypeHandicap(event: any): void {
		this.typeHandicapCsvFile = event.target.files[0];

		this.facade.typeHandicapService
			.importTypeHandicap(this.typeHandicapCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} typeHandicap ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getTypeHandicap();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addTypeHandicapModalRef = this.modalService.show(
			TypeHandicapModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addTypeHandicapModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeHandicap();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(typeHandicap: TypeHandicap) {
		const initialState = {
			typeHandicap: typeHandicap
		};
		this.editTypeHandicapModalRef = this.modalService.show(
			TypeHandicapModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editTypeHandicapModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeHandicap();
		});
	}
}
